//i18n-setup.js
import { createI18n } from 'vue-i18n';

export const i18n = createI18n({
    fallbackLocale: 'de',
    silentTranslationWarn: true
});

export function hasTranslation(key: string): boolean {
    try {
        const translation = i18n.global.t(key);
        return translation !== key;
    } catch (e) {
        return false;
    }
}
